import { createAction, props } from '@ngrx/store';
import { Company } from '../models/office.model';

export const setCompanies = createAction('[OfficeSelector Component] SetCompanies', props<{ companies: Company[] }>());
